@import (reference) '../../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';

.verify-domain-modal-content {
  gap: @space-16;
}

.help-article-link {
  .paragraph();
}

.advanced-options-section {
  border: none;
}

.advanced-options-section-open-header {
  border: none;
}

.advanced-options-section-content {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
}

.update-dns-records-section {
  gap: @space-8;
  padding: @space-0 @space-12;
  max-width: 500px;
}

.update-dns-settings-button {
  align-self: flex-end;
}

.advanced-options-section-header {
  padding: @space-16 @space-0;
}

.instructions-section {
  gap: @space-8;
}
